import {attachTooltips} from 'comp/tooltip';

var tips = [
    {
      selector: ".tip-mobile",
      copy: "This toggle must be turned on for visitors to see the mobile version.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    },
    {
      selector: ".tip-dtr-title",
      copy: "You can pass in dynamic text values to your title, through your page's URL. This is useful for increasing message match and quality score of your PPC campaigns.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    },
    {
      selector: ".tip-dtr-keywords",
      copy: "You can pass in dynamic text values to your keywords, through your page's URL. This is useful for increasing message match and quality score of your PPC campaigns.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    },
    {
      selector: ".tip-dtr-desc",
      copy: "You can pass in dynamic text values to your description, through your page's URL. This is useful for increasing message match and quality score of your PPC campaigns.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    },
    {
      selector: ".tip-save-template",
      copy: "This button only appears to Unbounce employees. Clicking this button will save this page as a template in Active Admin.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    },
    {
      selector: ".tip-auto-layout",
      copy: "Layout Assistant will do its best to organize your page to be mobile optimized.",
      disabled: false,
      color: 'white',
      size: 'small',
      position: 'fixed'
    }
  ];

function initTooltips() {
    attachTooltips(tips);
}

export default initTooltips;


// WEBPACK FOOTER //
// ./src/ui/tooltips.js